import { useState, useEffect, useRef } from 'react'
import { useLocation, useParams, Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import styles from './ClientLoad.module.css'
// ------ Services ------ //
import * as eventService from '../../../services/eventManagementService'
import * as clientEventService from '../../../services/clientEventService'
import * as siteManagementService from '../../../services/siteManagementService'
// ------ Components ------ //
import LoadingSpinner from "../../../components/Miscellaneous/LoadingSpinner"
const ClientLoad = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const passedState = location.state
    const passedPath = location.pathname
    const [loaded, setLoaded] = useState(false)
    const [loadClientObj, setLoadClientObj] = useState({})
    const [eRSList, setERSList] = useState([])
    const [eRSSelected, setERSSelected] = useState("")
    const [eRSValueSelected, setERSValueSelected] = useState(0)
    const [eRSRequestBody, setERSRequestBody] = useState({})
    const [reloadLazyLoadSelected, setReloadLazyLoadSelected] = useState(true)
    const LOCAL_STORAGE_KEY = "headerentries"// match header localstorage name
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }

    }
    const fetchERSOptions = async () => {
        const ERSListData = await siteManagementService.getAll()
        await setERSList(ERSListData)
    }
    const fetchClientDetails = async () => {
        let clientId;
        // used passed data, if its there
        if (passedState && passedState.clientId) {
            clientId = passedState.clientId;
        }
        else {
            clientId = clientEventInfo.clientId;
        }
        const clientDetail = await eventService.getClient(clientId)
        setLoadClientObj(clientDetail)
        setLoaded(true);
    }
    const isFormInvalid = () => {
        return !(eRSValueSelected)
    }
    const reloadClient = async e => {
        e.preventDefault()
        let request = reloadRequest()

        try {
            await eventService.reloadEventsByERS(request)
            localStorage.removeItem(LOCAL_STORAGE_KEY);
            navigate(-1)
        } catch (err) {
            console.log(err)
        }
    }
    const handleChange = (e) => {
        if (e.target.type === 'select-one') {
            let eRSSelectedIndex = eRSList.filter(pcl => pcl.eventRegistrationSystem === e.target.value)[0]
            setERSSelected(eRSSelectedIndex);
            setERSValueSelected(e.target.value);
        }
        else {
            //setFormData({
            //    ...formData,
            //    [e.target.name]: e.target.value,
            //})
        }
    }
    const reloadRequest = () => {
        let result = {}
        let clientidRef = passedState && passedState.clientId !== undefined && passedState.clientId !== '00000000-0000-0000-0000-000000000000' ? passedState.clientId : clientEventInfo.clientId;
        let clientnameRef = passedState && passedState.clientName !== undefined ? passedState.clientName : clientEventInfo.clientName;
        result = {
            client: {
                ClientId: clientidRef,
                ClientName: clientnameRef,
            },
            eventRegistrationSystemOptionSmall: {
                Id: eRSList.find((item) => item.eventRegistrationSystem === eRSValueSelected).id,
                EventRegistrationSystem: eRSValueSelected
            },
            ClientId: clientidRef
        }
        return result
    }
    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])
    useEffect(() => {
        fetchERSOptions()
    }, [])
    useEffect(() => {
        if ((clientEventInfo && clientEventInfo.clientId && clientEventInfo.clientId !== undefined) ||
            (passedState && passedState.clientId && passedState.clientId !== undefined)) {
            fetchClientDetails();
        }
        else {
            // assume that there hasn't been a selection yet for client or event
            setLoaded(true);
        }
    }, [clientEventInfo])
    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }
        //document.getElementById('fullCheck').checked = true;
    }, [])

    return (
         <>{!loaded ? <LoadingSpinner /> :
         <> 
            <div className="page-area">
                    <h1>Client Events for:</h1>
                    <h1>{loadClientObj.clientName}</h1>
                    <div id={styles.reloadSection}>
                        {
                            loadClientObj.impexiumCount > 0 ?
                                <h3>Impexium Event Count: {loadClientObj.impexiumCount}</h3>
                                : <></>

                        }
                        {
                            loadClientObj.edgeRegCount > 0 ?
                                <h3>EgeReg Event Count: {loadClientObj.edgeRegCount}</h3>
                                : <></>

                        }
                        {
                            loadClientObj.memberSuiteCount > 0 ?
                                <h3>MemberSuite Event Count: {loadClientObj.memberSuiteCount}</h3>
                                : <></>

                        }
                        {
                            loadClientObj.higherLogicCount > 0 ?
                                <h3>HigherLogic Event Count: {loadClientObj.higherLogicCount}</h3>
                                : <></>

                        }
                        {
                            loadClientObj.stovaCount > 0 ?
                                <h3>Stova Event Count: {loadClientObj.stovaCount}</h3>
                                : <></>

                        }
                        {
                            loadClientObj.gTRCount > 0 ?
                                <h3>GTR Event Count: {loadClientObj.gTRCount}</h3>
                                : <></>

                        }
                        {
                            loadClientObj.rhythmCount > 0 ?
                                <h3>Rhythm Event Count: {loadClientObj.rhythmCount}</h3>
                                : <></>

                        }
                        {
                            loadClientObj.swoogoCount > 0 ?
                                <h3>Swoogo Event Count: {loadClientObj.swoogoCount}</h3>
                                : <></>

                        }
                        
                    </div>
                    <h2>Select ERS for reload.</h2>
                    <h3>

                        <select
                            name="EventFilteringOption"
                            id={styles.ERSListDropdown}
                            value={eRSValueSelected}
                            onChange={e => handleChange(e)}
                        >
                            <option value="" selected="selected">
                                -- Select an option --
                            </option>

                            {
                                eRSList.map((efo, idx) => (
                                    <option key={idx}>{efo.eventRegistrationSystem}</option>
                                ))
                            }
                        </select>
                    </h3>
                    <div className={styles.reloadContainer}>
                        <label title="When un-checked, immediate reload is used. When checked, lazy-loader is used.">
                            <input
                                name="Required"
                                type="checkbox"

                                onClick={() => setReloadLazyLoadSelected(!reloadLazyLoadSelected)}
                                checked={reloadLazyLoadSelected}

                            />
                            Use lazy-loading
                        </label>
                        <br /><br />
                        <button onClick={reloadClient} disabled={isFormInvalid()}>
                            Reload Client
                        </button>
                        <br /> <br /> <br />
                        <button onClick={() => navigate(-1)}> Back </button> 
                    </div>
                    </div>
                
         </>
        }
        </>

    );
}

export default ClientLoad;